module.exports = __webpack_public_path__ + "static/media/steem.e7c244a2.png";